import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import style from '../../style/components/signin/RemoveDataModal.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import SelfieDeletionModal from './SelfieDeletionModal';
import CloseAccountModal from './CloseAccountModal';
import { EXISTS, PENDING, SELFIE_DELETE } from '../../constants';
import { fetchDataRequestByType } from '../../actions/dataRequests';
import StyledModal from '../StyledModal';

const RemoveDataModal = ({ closeModal, isOpen }) => {
  const { t } = useTranslation();

  const [isSelfieDeletionModalOpen, setIsSelfieDeletionModalOpen] =
    useState(false);
  const [isCloseAccountModalOpen, setIsCloseAccountModalOpen] = useState(false);

  const selfieStatus = useSelector((state) => state.dataRequests.selfie);

  const dispatch = useDispatch();
  useEffect(() => {
    // fetch selfie status upon modal open
    if (isOpen) {
      dispatch(fetchDataRequestByType(SELFIE_DELETE));
    }
  }, [isOpen, dispatch]);

  const REQUESTS = [];

  if (selfieStatus === EXISTS) {
    REQUESTS.push({
      description: t('dataRights.remove.selfie.description_risk'),
      title: t('dataRights.remove.selfie.heading_available'),
      onClick: () => {
        setIsSelfieDeletionModalOpen(true);
        closeModal();
      },
    });
  } else if (selfieStatus === PENDING) {
    REQUESTS.push({
      description: t('dataRights.remove.selfie.description_pendingProgress'),
      disabled: true,
      title: t('dataRights.remove.selfie.heading_pending'),
    });
  } else {
    REQUESTS.push({
      description: t('dataRights.remove.selfie.description_risk'),
      disabled: true,
      more_info: (
        <p>
          <strong>{t('dataRights.remove.selfie.notice_noSelfie')}</strong>
        </p>
      ),
      title: t('dataRights.remove.selfie.heading_available'),
    });
  }

  REQUESTS.push({
    description: t('dataRights.remove.closeAccount.description_timeline'),
    title: t('dataRights.remove.closeAccount.heading'),
    onClick: () => {
      setIsCloseAccountModalOpen(true);
      closeModal();
    },
  });

  return (
    <>
      <StyledModal
        isOpen={isOpen}
        closeModal={closeModal}
        title={t('dataRights.remove.title')}
      >
        <p>{t('dataRights.remove.description_legalRetention')}</p>

        {REQUESTS.map((request) => {
          return (
            <div
              key={request.title}
              className={`${style.tile} ${
                request.disabled ? style.disabledTile : ''
              }`}
              onClick={request.onClick}
            >
              <div className={style.tileBody}>
                <div className={style.content}>
                  <h4
                    className={`${style.heading} ${
                      request.disabled ? style.disabledHeading : ''
                    }`}
                  >
                    {request.title}
                  </h4>
                  <div>
                    <p>{request.description}</p>
                    {request.more_info}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </StyledModal>
      <SelfieDeletionModal
        isOpen={isSelfieDeletionModalOpen}
        closeModal={() => setIsSelfieDeletionModalOpen(false)}
      />
      <CloseAccountModal
        isOpen={isCloseAccountModalOpen}
        closeModal={() => setIsCloseAccountModalOpen(false)}
      />
    </>
  );
};

export default RemoveDataModal;
